import {BaseQueryApi, FetchArgs, FetchBaseQueryError} from '@reduxjs/toolkit/query';
import {captureException} from '@sentry/browser';

const DEFAULT_HTTP_METHOD = 'GET';
const SENTRY_FINGERPRINT_PREFIX = 'rtk-query';

type NumericFetchBaseQueryError = Extract<FetchBaseQueryError, {status: number}>;

export const captureBaseQueryError = (
  error: NumericFetchBaseQueryError,
  request: Pick<FetchArgs, 'method'>,
  api: Pick<BaseQueryApi, 'endpoint'>
) => {
  const statusTag = error.status.toString();

  captureException(new Error(`RTK Query request failed with status ${statusTag}`), {
    fingerprint: [SENTRY_FINGERPRINT_PREFIX, api.endpoint, statusTag],
    tags: {
      endpoint: api.endpoint,
      method: request.method ?? DEFAULT_HTTP_METHOD,
      status: statusTag,
    },
  });
};
